import React from "react";
import { Card, CardHeader, CardBody, Spinner } from "reactstrap";
import { getSeverityBadge } from "../utils/severityBadge";
import { threatCard, threatCardHeader, threatCardBody } from "./cardStyles";

const CriticalThreatsTable = ({ data, loading }) => {
  if (loading) {
    return (
      <Card style={threatCard}>
        <CardHeader style={threatCardHeader}>
          <h5 className="card-title mb-0">Recent Critical & High Severity Threats</h5>
        </CardHeader>
        <CardBody className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px", ...threatCardBody }}>
          <Spinner color="primary" />
        </CardBody>
      </Card>
    );
  }

  const threats = (data || []).slice(0, 5);

  return (
    <Card style={threatCard}>
      <CardHeader style={threatCardHeader}>
        <h5 className="card-title mb-0">Recent Critical & High Severity Threats</h5>
      </CardHeader>
      <CardBody className="p-0">
        {threats.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-hover table-nowrap align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th style={{ padding: "12px 16px", fontSize: "11px", fontWeight: "600", textTransform: "uppercase" }}>Severity</th>
                  <th style={{ padding: "12px 16px", fontSize: "11px", fontWeight: "600", textTransform: "uppercase" }}>Rule ID</th>
                  <th style={{ padding: "12px 16px", fontSize: "11px", fontWeight: "600", textTransform: "uppercase" }}>Description</th>
                  <th style={{ padding: "12px 16px", fontSize: "11px", fontWeight: "600", textTransform: "uppercase" }}>Agent</th>
                  <th style={{ padding: "12px 16px", fontSize: "11px", fontWeight: "600", textTransform: "uppercase" }}>Threat Type</th>
                  <th style={{ padding: "12px 16px", fontSize: "11px", fontWeight: "600", textTransform: "uppercase" }}>Timestamp</th>
                  <th style={{ padding: "12px 16px", fontSize: "11px", fontWeight: "600", textTransform: "uppercase", textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {threats.map((threat, index) => (
                  <tr key={index}>
                    <td style={{ padding: "12px 16px" }}>
                      {getSeverityBadge(threat.severity)}
                    </td>
                    <td style={{ padding: "12px 16px", fontFamily: "monospace", fontSize: "12px", fontWeight: "500" }}>
                      {threat.ruleId || 'N/A'}
                    </td>
                    <td style={{ padding: "12px 16px" }}>
                      <div style={{ 
                        maxWidth: "300px", 
                        whiteSpace: "normal", 
                        wordBreak: "break-word",
                        fontSize: "12px",
                        lineHeight: "1.5"
                      }}>
                        {threat.description || 'No description'}
                      </div>
                    </td>
                    <td style={{ padding: "12px 16px", fontSize: "12px" }}>{threat.agent || 'Unknown'}</td>
                    <td style={{ padding: "12px 16px" }}>
                      <span className="badge text-primary border border-danger-subtle rounded"  style={{ fontSize: "11px", fontWeight: "500" ,color: "#99999bff"}}>
                        {threat.mitre || 'N/A'}
                      </span>
                    </td>
                    <td style={{ padding: "12px 16px", fontSize: "11px", color: "var(--vz-body-color)" }}>
                      {threat.timestamp}
                    </td>
                    <td style={{ padding: "12px 16px", textAlign: "center" }}>
                      <a 
                        href={`/ThreatGuard?id=${threat.threat_id}`}
                        className="btn btn-sm"
                         style={{
                          backgroundColor: "rgba(7, 82, 57, 0.1)",
                          color: "#9b9898ff",
                          border: "1px solid #FF5B00",
                          padding: "5px 12px",
                          borderRadius: "6px",
                          fontSize: "11px",
                          fontWeight: "500",
                          textDecoration: "none"
                        }}
                      >
                        <i className="ri-eye-line me-1"></i>View
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center text-muted py-5">
            No critical threats found
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default CriticalThreatsTable;
